var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 30.0007C6.66666 28.2325 7.36904 26.5368 8.61928 25.2866C9.86952 24.0364 11.5652 23.334 13.3333 23.334H26.6667C28.4348 23.334 30.1305 24.0364 31.3807 25.2866C32.6309 26.5368 33.3333 28.2325 33.3333 30.0007C33.3333 30.8847 32.9821 31.7326 32.357 32.3577C31.7319 32.9828 30.884 33.334 30 33.334H9.99999C9.11593 33.334 8.26809 32.9828 7.64297 32.3577C7.01785 31.7326 6.66666 30.8847 6.66666 30.0007Z",
    stroke: "#30313E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.667C22.7614 16.667 25 14.4284 25 11.667C25 8.90557 22.7614 6.66699 20 6.66699C17.2386 6.66699 15 8.90557 15 11.667C15 14.4284 17.2386 16.667 20 16.667Z",
    stroke: "#30313E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f8709bfc8cf37db8f30ede774315900b.svg";
export { ForwardRef as ReactComponent };